import { defineStore } from 'pinia';

export const useGuardianStore = defineStore('guardian', {
    state: () => ({
        activeTab: 'NEW',
        isPanelVisible: false,
        threadId: null,
        queryText: '',
        currentGuardian: null, // { id, name, agentType }
    }),
    actions: {
        openNew(guardian) {
            /**
             * Open the guardian panel to the "New Chat" tab
             */
            this.currentGuardian = guardian;
            this.isPanelVisible = true;
            this.activeTab = 'NEW';
        },

        openHistory(guardian) {
            this.currentGuardian = guardian;
            this.isPanelVisible = true;
            this.activeTab = 'HISTORY';
        },

        openThread(threadIdOrQueryText, guardian) {
            this.currentGuardian = guardian;
            this.threadId = typeof threadIdOrQueryText == 'string' ? -1 : threadIdOrQueryText;
            this.queryText = typeof threadIdOrQueryText != 'string' ? '' : threadIdOrQueryText;
            this.isPanelVisible = true;
            this.activeTab = 'THREAD';
        },

        setQueryText(text) {
            this.queryText = text;
        },

        closePanel() {
            this.isPanelVisible = false;
        },
    },

    getters: {},
});

